import React from "react";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import { ChevronUpIcon } from "../Icons/Arrows/ChevronUpIcon";
import "./Accordion.scss";

/**
 * Componente Accordion personalizado basado en MUI
 *
 * @param {Object} props - Propiedades del componente
 * @param {string} props.title - Texto que se muestra en el header del accordion
 * @param {string} [props.titleTooltip] - Tooltip que se muestra al hacer hover sobre el título (útil cuando el título está truncado con ellipsis)
 * @param {React.ReactNode} props.children - Contenido que se muestra dentro del accordion (ej: checkboxes, formularios)
 * @param {boolean} [props.defaultExpanded=false] - Define si el accordion inicia expandido o colapsado
 * @param {string} [props.className=''] - Clases CSS adicionales para personalizar el estilo
 * @param {string} [props.titleClassName=''] - Clases CSS adicionales para personalizar el titulo
 */
export const Accordion = ({
  title,
  titleTooltip,
  children,
  defaultExpanded = false,
  className = "",
  titleClassName = "",
  ...props
}) => {
  return (
    <MuiAccordion
      defaultExpanded={defaultExpanded}
      className={`custom-accordion ${className}`}
      disableGutters
      elevation={0}
      {...props}
    >
      <MuiAccordionSummary
        expandIcon={<ChevronUpIcon className="accordion-chevron" />}
      >
        <div className="accordion-header-content">
          <span
            className={
              titleClassName !== "" ? titleClassName : "accordion-title"
            }
            title={titleTooltip}
          >
            {title}
          </span>
        </div>
      </MuiAccordionSummary>
      <MuiAccordionDetails>{children}</MuiAccordionDetails>
    </MuiAccordion>
  );
};
